module.exports = __webpack_public_path__ + "img/icon_highlight_niulong.588e2ff8.png";